/* eslint-disable */
import httpClient from '@/utils/httpClient'

class ParkManagmentSettingsRepository extends httpClient {
  resource = '/park_management/settings';

  async getAllSettings (params) {
    const response = await this.get(`${this.resource}`, { params })
    return response ?? {}
  }

  async getServiceMileage () {
    return  await this.get(`${this.resource}/mileage_services`)
  }

  async updateServiceMileage (data) {
    return  await this.put(`${this.resource}/mileage_services`, data)
  }

  /**
   * получение настроек условий работы водителей
   * @returns {Promise<[{taxiServiceId: string, minBalance: number, crontab: string, regionParks: [{name: string, regionParkId: string}], isEnabled: boolean, name: string, id: string, parkId: string}]>}
   */
  async getDriverWorkRules () {
    const response = await this.get(`${this.resource}/driver_work_rules`, {})
    return response?.driverWorkRules ?? []
  }

  /**
   * установка настроек условий работы водителей
   * @param {{taxiServiceId: string, minBalance: number, crontab: string, regionParks: [{name: string, regionParkId: string}], isEnabled: boolean, name: string, id: string, parkId: string}} data
   * @returns {Promise<{taxiServiceId: string, minBalance: number, crontab: string, regionParks: [{name: string, regionParkId: string}], isEnabled: boolean, name: string, id: string, parkId: string}>}
   */
  async updateDriverWorkRules (data) {
    const response = await this.put(`${this.resource}/driver_work_rules`, data)
    return response?.driverWorkRule ?? {}
  }

  /**
   * установка настроек для арендного парка
   * @param {{showWaybillIndicators: boolean, depositStopLine: number, finesEnableTollRoad: boolean, remindDownloadWaybill: boolean, regionParkId: string, startFullDay: number, bonusIsTip: number, washerSum: number, internalInsurance: number, companyProfit: number, depositSum: number, finesServiceSum: string, finesDiscountPercent: string, timerWorkingIndicator: number, carsUpdateFrequency: number, maintenanceFrequency: number }} data
   * @returns {Promise<*|{}>}
   */
  async updateSettingsRent (data) {
    const response = await this.put(`${this.resource}/rent_settings`, data)
    return response ?? {}
  }

  async regionParkUseCommonSettings (params) {
    const response = await this.post(`${this.resource}/region_park_use_common_settings`, null, { params })
    return response
  }

  async regionParkUseOwnSettings (params) {
    const response = await this.post(`${this.resource}/region_park_use_own_settings`, null, { params })
    return response
  }

  async getDriversPercents (params) {
    const response = await this.get(`${this.resource}/drivers_percents`, { params })
    return response ?? ''
  }

  async updateDriversPercents (data) {
    const response = await this.put(`${this.resource}/drivers_percents`, data)
    return response?.driversPercents ?? ''
  }

  async updateFines (data) {
    const response = await this.put(`${this.resource}/fines`, data)
    return response?.fines ?? ''
  }

  async updateMyavoAPICredentials (data) {
    const response = await this.put(`${this.resource}/myavo_api_credentials`, data)
    return response ?? {}
  }

  async updateFinesServiceKey (data) {
    const response = await this.put(`${this.resource}/fines_service_key`, data)
    return response ?? {}
  }

  async updateYandexTaxiAPICredentials (data) {
    const response = await this.put(`${this.resource}/yandex_taxi_api_credentials`, data)
    return response ?? {}
  }

  async updateTimeZone (data) {
    const response = await this.put(`${this.resource}/time_zone`, data)
    return response ?? {}
  }

  /**
   *
   * @param data
   * @returns {Promise<{morningBorderChange: number, carsUpdateFrequency: number, maintenanceFrequency: number, nightBorderChange: number, startFullDay: number, finesServiceSum: string, fixedPercent: number, bonusIsTip: number, depositSum: number, companyProfit: number, washerSum: number, timerWorkingIndicator: number, internalInsurance: number, finesDiscountPercent: string, fixedSum: number}>}
   */
  async updateCommonSettings (data) {
    const response = await this.put(`${this.resource}/common_settings`, data)
    return response ?? {}
  }

  /**
   * Обновление порогов удержания
   * @param data
   * @returns {Promise<{mins: [{name: string, value: number}], regionParkId: string, maxes: [{name: string, value: number}]}>}
   */
  async updateRetentionBorders (data) {
    const response = await this.put(`${this.resource}/retention_borders`, data)
    return response ?? {}
  }
}

export default ParkManagmentSettingsRepository
